import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { config } from '../../providers/config';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Router, RouterModule, Routes } from '@angular/router';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AuthService {
  loginUrl = '/api/token/auth/';
  forgotUrl = '/api/v1/password/reset/';
  userUrl = '/api/v1/users/';
  getUserinfoUrl = '/api/v1/users/'
  httpNewOptions:object={};
  constructor(private http:HttpClient,private router:Router) { }
 
  // Login authentication
  login(model) {
    let body = JSON.stringify({username:model.username,password:model.password});
    return this.http.post(this.getFullUrl(this.loginUrl), body, httpOptions).map((res:Response) => {
      let data = res;
      if(data) {
        let accessToken = data['token'];
        localStorage.setItem('token', accessToken);
        this.getCurrentUser();
      }
      return res;
    })
  }

  getUserRole(userId) {
    return this.http.get(this.getFullUrl(this.getUserinfoUrl+`${userId}/`),this.getHeader()).map((res) => {
      return res;
    })
  }

  // Reset password
  resetPassword(email) {
    let body = JSON.stringify({reset_for:email});
    return this.http.post(this.getFullUrl(this.forgotUrl), body, httpOptions).map((res:Response) => {
      return res;
    })
  }

  //Create new password
  setPassword(model) {
    let body = JSON.stringify({password:model.current_password,new_password:model.new_password,new_password_confirm:model.new_password_repeat});
    return this.http.put(this.getFullUrlWithUserId(this.userUrl,'/password/set/'), body, this.getHeader()).map((res:Response) => {
      return res;
    })
  }

  // Update user details
  updateUserDetails(model) {
    return this.http.put(this.getFullUrlWithUserId(this.userUrl,'/'), model, this.getHeader()).map((res:Response) => {
      return res;
    })
  }

  // Update user Triggers
  updateUserTriggers(status) {
    let userId = localStorage.getItem('user_id');
    let body = JSON.stringify({id:userId, triggers: {first_login: status}});
    return this.http.put(this.getFullUrlWithUserId(this.userUrl,'/triggers/'), body, this.getHeader()).map((res:Response) => {
      return res;
    })
  }

  // Upload user image
  uploadImage(body) {
    return this.http.put(this.getFullUrlWithUserId(this.userUrl,'/image/'), body, this.getHeader('no')).map((res:Response) => {
      return res;
    })
  }


  // Logout
  logOut() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  

  // Decode the logged in user details using the token.
  getCurrentUser(){
    let token = localStorage.getItem('token');
    let decodeObj={};
    if(token) {
      let base64Url = token.split('.')[1];
      let base64 = base64Url.replace('-', '+').replace('_', '/');
      decodeObj = JSON.parse(window.atob(base64));
      localStorage.setItem('user_id', decodeObj['user_id']);
    }
    return decodeObj;
  }

  //To get the full api url
  private getFullUrl(url: string): string {
    return config.api_url + url;
  }

  // To get the full api url and userid in the url
  private getFullUrlWithUserId(url: string, extUrl:string): string {
    let userId = localStorage.getItem('user_id');
    return config.api_url+url+userId+extUrl;
  }

  //To get the the http headers.
  private getHeader(value?) {
    let token = localStorage.getItem('token');
    if(value == 'no') {
      this.httpNewOptions = {
        headers: new HttpHeaders({'authorization': `JWT ${token}` })
      };
    } else {
      this.httpNewOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': `JWT ${token}` })
      };
    }
    return this.httpNewOptions;
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/services/auth.service.ts